import { ESpecie } from 'shared/api';

/**
 * Получение текстового представления вида животного
 * @param specie - Вид животного
 * @returns Текстовое представление вида
 */
export const getSpecieText = (specie: ESpecie | undefined): string => {
  if (!specie) return 'Не указан';

  if (specie === ESpecie.Dog) return 'Dog';
  if (specie === ESpecie.Cat) return 'Cat';

  return 'Unknown';
};

/**
 * Получение статуса верификации в текстовом виде
 * @param verified - Статус верификации
 * @returns Текстовое представление статуса
 */
export const getVerifiedText = (verified: boolean): string => {
  return verified ? 'Verified' : 'Not verified';
};
